import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { useGetGenresListQuery } from 'store/api/yay/misc'
import { useGetGamesAppsQuery } from 'store/api/yay/games'
import { setCallTimelineFilters } from 'store/actions/conferenceCall'

import usePageModal from 'features/Modal/hooks/usePageModal'
import { Link, useNavigate } from 'features/i18n/router'
import { snowplowEvent } from 'lib/analytics'

import {
  Categories,
  CategoriesTitle,
  CategoriesGrid,
} from 'components/Categories'
import AsyncListDataComponent from 'components/AsyncListDataComponent'

import { MODAL_MODE } from '../config'

import './style.scss'
import { InfiniteScrollList } from 'components/InfiniteScrollList/InfiniteScrollList'

const SelectCategoryModal = ({ location, modalMode, ...params }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { generatePageModalUrl } = usePageModal()

  const genreList = useGetGenresListQuery({})

  return (
    <div className="Modal__wrapper SelectCategoryModal">
      <div className="Modal__header">
        <Link
          className="Modal__header__close Modal__header__close--back"
          to={generatePageModalUrl(MODAL_MODE.CALL_LIST_MODAL, params)}
          onClick={() => snowplowEvent.open_call_list()}
        />

        <h2 className="Modal__header__h2">{t('call_category_title')}</h2>
      </div>

      <div className={'Modal__body'}>
        <Categories>
          <CategoriesTitle>
            {t('call_category_modal.genre_list.title')}
          </CategoriesTitle>
          <AsyncListDataComponent {...genreList} data={genreList?.data?.genres}>
            {(genres) => (
              <CategoriesGrid
                categories={genres}
                onClick={(genre) => {
                  dispatch(setCallTimelineFilters('category', genre))
                  snowplowEvent.open_call_list()

                  navigate(
                    generatePageModalUrl(MODAL_MODE.CALL_LIST_MODAL, params)
                  )
                }}
              />
            )}
          </AsyncListDataComponent>
        </Categories>

        <Categories>
          <CategoriesTitle>
            {t('call_category_modal.game_list.title')}
          </CategoriesTitle>
          <InfiniteScrollList
            query={{
              useQuery: useGetGamesAppsQuery,
            }}
          >
            {({ list }) => (
              <CategoriesGrid
                categories={list}
                onClick={(game) => {
                  dispatch(setCallTimelineFilters('category', game))
                  snowplowEvent.open_call_list()

                  navigate(
                    generatePageModalUrl(MODAL_MODE.CALL_LIST_MODAL, params)
                  )
                }}
              />
            )}
          </InfiniteScrollList>
        </Categories>
      </div>
    </div>
  )
}

export default SelectCategoryModal
